import { Box, useTheme } from '@mui/material';
import { FC } from 'react';
import { PolicyOverview, PolicyStatus } from '@acorn-portal/shared/src/services/api';
import CircleIcon from '@mui/icons-material/Circle';

interface Props {
	policy: PolicyOverview;
}

const PolicyOverviewStatusField: FC<Props> = ({ policy }: Props) => {
	const themeUtils = useTheme();

	let text = '';
	let statusColor = '';
	switch (policy.policyStatus) {
		case PolicyStatus.EndOfProduct:
			text = 'Your Policy Is Due To Expire';
			statusColor = themeUtils.palette.warning.dark;
			break;
		case PolicyStatus.Active:
			text = "You're Covered";
			statusColor = themeUtils.palette.success.main;
			break;
		case PolicyStatus.RenewalTakenUp:
			text = 'Your Renewal has Been Purchased';
			statusColor = themeUtils.palette.success.main;
			break;
		case PolicyStatus.DueForRenewal:
		case PolicyStatus.DueToExpire:
			if (policy.renewalDeclined) {
				text = 'Your Policy Is Due To Expire';
				statusColor = themeUtils.palette.warning.dark;
			} else if (policy.autoRenewal) {
				text = 'Your Policy Will Automatically Renew';
				statusColor = themeUtils.palette.success.main;
			} else {
				text = 'Your Policy Will Expire Soon';
				statusColor = themeUtils.palette.warning.dark;
			}
			break;
		case PolicyStatus.Cancelled:
			text = 'Policy Cancelled';
			statusColor = themeUtils.palette.error.main;
			break;
		case PolicyStatus.Expired:
			text = 'Policy Expired';
			statusColor = themeUtils.palette.text.disabled;
			break;
		case PolicyStatus.Pending:
			text = 'Pending Cover';
			statusColor = themeUtils.palette.warning.light;
			break;
		case PolicyStatus.CancellationPending:
			text = 'Cancellation Pending';
			statusColor = themeUtils.palette.text.secondary;
			break;
		default:
			break;
	}
	return (
		<Box display='flex' className='policy-status-field'>
			<Box
				sx={{
					color: statusColor,
					fontSize: '1.1rem',
					fontWeight: 500,
				}}
				component='span'
			>
				<CircleIcon sx={{ color: statusColor, fontSize: '0.9rem', marginRight: '10px' }} />
				{text}
			</Box>
		</Box>
	);
};

export default PolicyOverviewStatusField;
